var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10000 5000",
    width: 10000,
    height: 5000,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Guber+Arrow(Green)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t\t.shp0 { fill: #abfaa3 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Folder 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "guber logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arrow5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape 3 copy",
    className: "shp0",
    d: "M1593.25 3015.18L1966.02 3226.29L1737.68 3629.49L1364.91 3418.38L1593.25 3015.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer 12",
    className: "shp0",
    d: "M1710.87 3610.76L1824.52 3680.7C1824.52 3680.7 1861.68 3716.7 1859.5 3654.47C1857.31 3592.24 1859.5 3444.64 1859.5 3444.64L2069.32 3313.5C2069.32 3313.5 2113.59 3304.7 2025.61 3261.04C1937.64 3217.39 1929.44 3208.58 1929.44 3208.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer 16",
    className: "shp0",
    d: "M1730 3625L1837 3690L1844 3683L1842 3661L1794 3622"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer 14",
    className: "shp0",
    d: "M2045 3329L2078 3309C2078 3309 2112.75 3297.22 1966 3227C1819.25 3156.78 1819 3157 1819 3157L1899 3198L1891 3217"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer 15",
    className: "shp0",
    d: "M1948 3216L2035 3263L2029 3277L1971 3276L1919 3222L1899 3203"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer 8 copy",
    className: "shp0",
    d: "M1623.73 3038.59L1585.69 3017.05L1361.62 3412.72L1422.52 3447.12L1646.59 3051.45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape 1",
    className: "shp0",
    d: "M1300.26 3547.82C1294.89 3544.72 1291.58 3538.99 1291.59 3532.79L1291.66 3116.97C1291.66 3110.77 1294.97 3105.05 1300.34 3101.95L1660.49 2894.1C1665.85 2891 1672.47 2891 1677.84 2894.1L1300.26 3547.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Arrow4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bottom"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer 2",
    className: "shp0",
    d: "M3057.09 3061.77L2607.08 3054.34L2608.08 3559.69L2794.17 3657.03C2794.17 3657.03 3057.03 3669.98 3061.92 3438.09C3066.81 3206.19 3057.09 3061.77 3057.09 3061.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer 11",
    className: "shp0",
    d: "M2607.08 3121.15L2607.08 2981.27L3057.27 2710.24L3057.27 3112.41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Tip"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer 3",
    className: "shp0",
    d: "M2843.65 3684.23C2843.65 3684.23 2816.61 3719.16 2723.21 3666.26C2629.8 3613.37 2327.61 3442.23 2327.61 3442.23L2103.58 3837.83L2354.63 3980C2354.63 3980 2935.92 3719.74 2843.65 3684.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape 3",
    className: "shp0",
    d: "M2200.52 3367.16L2573.3 3578.27L2344.96 3981.47L1972.18 3770.36L2200.52 3367.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer 13",
    className: "shp0",
    d: "M2322 3968L2344 3981C2344 3981 2347 3984.58 2366 3975C2385 3965.42 2382 3951 2382 3951"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer 8",
    className: "shp0",
    d: "M2231 3390.57L2192.97 3369.03L1968.89 3764.7L2029.79 3799.1L2253.87 3403.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape 1 copy",
    className: "shp0",
    d: "M1926.26 3917.82C1920.89 3914.72 1917.58 3908.99 1917.59 3902.79L1917.66 3486.97C1917.66 3480.77 1920.97 3475.05 1926.34 3471.95L2286.49 3264.1C2291.85 3261 2298.47 3261 2303.84 3264.1L1926.26 3917.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer 10",
    className: "shp0",
    d: "M2527.65 3552.42L2755.88 3681.67L2712.8 3757.74L2484.57 3628.49L2527.65 3552.42Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Arrow3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tip"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer 7",
    className: "shp0",
    d: "M1850.75 1792.24L1614.7 1932.13L1413.61 1809.73C1413.61 1809.73 1288.3 1558.94 1474.81 1477.5C1661.32 1396.06 1649.67 1390.07 1649.67 1390.07L1885.72 1774.75L1850.75 1792.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape 4",
    className: "shp0",
    d: "M1634 1380L1442 1496L1458 1509C1458 1509 1565 1480.47 1566 1480C1567 1479.53 1618 1445 1618 1445"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer 5",
    className: "shp0",
    d: "M1764.75 1844.08L1890.85 1771.28L1663.49 1377.49L1461.77 1494.04L1689.13 1887.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape 1 copy 3",
    className: "shp0",
    d: "M1550.86 1274.05C1556.23 1270.95 1562.85 1270.95 1568.22 1274.05L1928.29 1482.03C1933.66 1485.13 1936.96 1490.86 1936.96 1497.05L1936.89 1912.87C1936.89 1919.07 1933.58 1924.8 1928.21 1927.9L1550.86 1274.05Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Bottom"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer 3",
    className: "shp0",
    d: "M1375.16 1785.04C1375.16 1785.04 1358.77 1826.05 1451.73 1879.72C1544.69 1933.39 1845.45 2107.04 1845.45 2107.04L1618.14 2500.76L1368.28 2356.5C1368.28 2356.5 1297.76 1723.52 1375.16 1785.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape 2",
    className: "shp0",
    d: "M1617.14 1976.01L2042.27 2221.46L1814.96 2615.18L1389.83 2369.73L1617.14 1976.01Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Arrow2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bottom"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer 2",
    className: "shp0",
    d: "M3057.09 2003.88L2607.08 1996.45L2608.08 2501.8L2794.17 2599.15C2794.17 2599.15 3057.03 2612.09 3061.92 2380.2C3066.81 2148.31 3057.09 2003.88 3057.09 2003.88Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Tip"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape 1 copy 2",
    className: "shp0",
    d: "M2026.26 2907.82C2020.89 2904.72 2017.58 2898.99 2017.59 2892.79L2017.66 2476.97C2017.66 2470.77 2020.97 2465.05 2026.34 2461.95L2386.49 2254.1C2391.85 2251 2398.47 2251 2403.84 2254.1L2026.26 2907.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer 3",
    className: "shp0",
    d: "M2847.17 2629.75C2847.17 2629.75 2819.84 2664.44 2726.89 2610.77C2633.93 2557.11 2333.17 2383.46 2333.17 2383.46L2105.85 2777.18L2355.71 2921.44C2355.71 2921.44 2939.15 2666.02 2847.17 2629.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer 5",
    className: "shp0",
    d: "M2333.17 2383.46L2295.31 2361.6L2067.95 2755.4L2128.57 2790.29L2355.92 2396.5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Arrow1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bottom"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer 2",
    className: "shp0",
    d: "M1903.21 1241.44L2121.78 1634.87L2558.93 1381.33L2550.18 1171.5C2550.18 1171.5 2429.97 937.39 2226.7 1049.1C2023.42 1160.81 1903.21 1241.44 1903.21 1241.44Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Tip"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer 3",
    className: "shp0",
    d: "M2550.18 1110.3C2550.18 1110.3 2593.9 1116.61 2593.9 1223.95C2593.9 1331.29 2593.9 1678.58 2593.9 1678.58L3048.53 1678.58L3048.53 1390.07C3048.53 1390.07 2535.61 1012.51 2550.18 1110.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape 1 copy 4",
    className: "shp0",
    d: "M3202.56 1678.01C3202.56 1684.21 3199.25 1689.94 3193.88 1693.04L2833.73 1900.88C2828.36 1903.98 2821.75 1903.98 2816.38 1900.88L2456.31 1692.91C2450.94 1689.81 2447.63 1684.08 2447.63 1677.88L3202.56 1678.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer 5",
    className: "shp0",
    d: "M2593.9 1678.58L2593.9 1722.3L3048.61 1722.3L3048.53 1652.35L2593.81 1652.35"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Arrow4 copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bottom"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer 2",
    className: "shp0",
    d: "M7389.38 3977.84L7383.56 3625.32L7779.44 3626.1L7855.7 3771.88C7855.7 3771.88 7865.84 3977.8 7684.18 3981.63C7502.52 3985.46 7389.38 3977.84 7389.38 3977.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer 11",
    className: "shp0",
    d: "M7435.9 3625.32L7326.32 3625.32L7114 3979.8L7429.05 3979.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape 5",
    className: "shp0",
    d: "M3282 3625L7664 3625L7664 3983L3282 3983L3282 3625Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer 18",
    className: "shp0",
    d: "M3307 3983L2813 3983C2813 3983 3233 3751.89 3283 3626"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Tip"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer 3",
    className: "shp0",
    d: "M7877 3810.64C7877 3810.64 7904.37 3789.46 7862.93 3716.29C7821.49 3643.11 7687.43 3406.38 7687.43 3406.38L7997.33 3230.88L8108.7 3427.55C8108.7 3427.55 7904.82 3882.92 7877 3810.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape 3",
    className: "shp0",
    d: "M7628.62 3306.82L7794 3598.85L8109.86 3419.98L7944.48 3127.95L7628.62 3306.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer 13",
    className: "shp0",
    d: "M8099.3 3401.99L8109.49 3419.22C8109.49 3419.22 8112.29 3421.57 8104.79 3436.46C8097.28 3451.34 8085.99 3448.99 8085.99 3448.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer 8",
    className: "shp0",
    d: "M7646.96 3330.7L7630.08 3300.91L7940.04 3125.37L7966.99 3173.08L7657.03 3348.62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape 1 copy",
    className: "shp0",
    d: "M8059.99 3091.97C8057.57 3087.77 8053.08 3085.18 8048.22 3085.18L7722.47 3085.24C7717.62 3085.24 7713.14 3087.83 7710.71 3092.04L7547.88 3374.17C7545.45 3378.37 7545.45 3383.56 7547.88 3387.76L8059.99 3091.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer 10",
    className: "shp0",
    d: "M7773.75 3563.09L7875 3741.88L7934.59 3708.13L7833.34 3529.34L7773.75 3563.09Z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "uber. ",
    fill: "#abfaa3",
    "aria-label": "uber.",
    d: "M4187.7 1668.67L4187.7 2204.79C4187.7 2404.32 4082.89 2497.03 3937.78 2497.03C3798.71 2497.03 3718.09 2416.41 3718.09 2235.02L3718.09 1668.67L3403.67 1668.67L3403.67 2281.37C3403.67 2615.95 3595.14 2769.12 3867.23 2769.12C4000.26 2769.12 4121.19 2718.74 4203.82 2624.01L4203.82 2753L4502.11 2753L4502.11 1668.67ZM5457.46 1652.54C5322.42 1652.54 5211.57 1694.87 5130.95 1783.55L5130.95 1257.51L4816.53 1257.51L4816.53 2753L5116.84 2753L5116.84 2628.04C5195.44 2722.77 5312.34 2769.12 5457.46 2769.12C5761.8 2769.12 5997.61 2551.45 5997.61 2210.83C5997.61 1870.21 5761.8 1652.54 5457.46 1652.54ZM5403.04 2511.14C5245.83 2511.14 5126.92 2398.27 5126.92 2210.83C5126.92 2023.39 5245.83 1910.52 5403.04 1910.52C5560.25 1910.52 5679.16 2023.39 5679.16 2210.83C5679.16 2398.27 5560.25 2511.14 5403.04 2511.14ZM7291.56 2214.86C7291.56 1866.18 7045.67 1652.54 6727.22 1652.54C6396.68 1652.54 6148.77 1886.34 6148.77 2210.83C6148.77 2533.31 6392.65 2769.12 6767.53 2769.12C6963.03 2769.12 7114.19 2708.66 7214.97 2593.78L7047.68 2412.38C6973.11 2482.92 6890.47 2517.19 6775.59 2517.19C6610.32 2517.19 6495.44 2434.55 6465.2 2299.51L7285.51 2299.51C7287.52 2273.31 7291.56 2239.05 7291.56 2214.86ZM6729.23 1890.37C6870.32 1890.37 6973.11 1979.05 6995.28 2116.1L6461.17 2116.1C6483.34 1977.04 6586.13 1890.37 6729.23 1890.37ZM7823.65 1811.77L7823.65 1668.67L7523.34 1668.67L7523.34 2753L7837.75 2753L7837.75 2241.07C7837.75 2033.47 7952.64 1938.74 8125.97 1938.74C8150.15 1938.74 8170.31 1940.76 8196.51 1942.77L8196.51 1652.54C8029.23 1652.54 7900.23 1706.96 7823.65 1811.77ZM8512.94 2769.12C8621.78 2769.12 8708.45 2686.49 8708.45 2571.61C8708.45 2454.71 8621.78 2378.12 8512.94 2378.12C8404.11 2378.12 8317.44 2454.71 8317.44 2571.61C8317.44 2686.49 8404.11 2769.12 8512.94 2769.12Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6bd7e15da6a4f320c536aac86b646fd5.svg";
export { ForwardRef as ReactComponent };